import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ac16fb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-6 col-lg-1 order-1 order-lg-0 d-flex justify-content-start justify-content-lg-center align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "22",
  height: "24",
  viewBox: "0 0 22 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.939341 10.9393C0.353554 11.5251 0.353554 12.4749 0.939341 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97919 12.6066 1.3934C12.0208 0.807611 11.0711 0.807611 10.4853 1.3934L0.939341 10.9393ZM22 10.5L2 10.5V13.5L22 13.5V10.5Z",
    fill: "white"
  })
], -1))
const _hoisted_4 = { class: "col-12 col-lg-10 order-0 order-lg-1" }
const _hoisted_5 = {
  id: "imagery",
  class: "position-relative w-100 h-100"
}
const _hoisted_6 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_7 = { class: "w-100 h-100" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "futura pt-2" }
const _hoisted_10 = { class: "col-6 col-lg-1 order-2 order-lg-2 d-flex justify-content-end justify-content-lg-center align-items-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "22",
  height: "24",
  viewBox: "0 0 22 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.939341 10.9393C0.353554 11.5251 0.353554 12.4749 0.939341 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97919 12.6066 1.3934C12.0208 0.807611 11.0711 0.807611 10.4853 1.3934L0.939341 10.9393ZM22 10.5L2 10.5V13.5L22 13.5V10.5Z",
    fill: "white"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Btn, { class: "swiper-button-prev" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_swiper, {
          modules: _ctx.swiper.modules,
          navigation: _ctx.swiper.navigation,
          "slides-per-view": 1,
          loop: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imagery, ([image, caption], index) => {
              return (_openBlock(), _createBlock(_component_swiper_slide, { key: index }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("figure", _hoisted_7, [
                      _createElementVNode("img", {
                        src: require(`@/assets/images/gallery/${image}`),
                        alt: caption,
                        class: "swipe-item w-auto h-100 d-block mx-auto"
                      }, null, 8, _hoisted_8),
                      _createElementVNode("figcaption", _hoisted_9, _toDisplayString(caption), 1)
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["modules", "navigation"])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_Btn, { class: "swiper-button-next" }, {
        default: _withCtx(() => [
          _hoisted_11
        ]),
        _: 1
      })
    ])
  ]))
}